export default {
  routes_home: 'Accueil',
  routes_take_duet: 'Compléter Duet',
  routes_duet_profile: 'Gérer le profil',
  routes_assessment_results: 'Résultats des évaluations',
  routes_download_assessment_results:
    'Télécharger les résultats des évaluations',
  routes_users: 'Utilisateurs',
  routes_access_logs: 'Accéder aux journaux de données',
  routes_configure_school: `Configuration d'établissement`,
  routes_configure_users: 'Configuration des utilisateurs',
  routes_manage_permissions: 'Gestion des permissions',
  routes_configure_menu: 'Menu de configuration',
  routes_configure_integrations: 'Configuration des intégrations',
  routes_terms_and_conditions: 'Conditions générales',
  routes_signin: 'Se connecter',
  routes_reset_password: 'Réinitialiser mot de passe',
  routes_taggings_and_embellishments: 'Marquages et Enjolivement',
  routes_manage_users: 'Gérez vos utilisateurs',
  routes_edit_user: `Modifier l'utilisateur`,
  routes_not_found: '404 - Page non trouvée',
  routes_forbidden: '403 - Accès interdit',
  routes_logout: 'Se déconnecter',
  routes_create_user: 'Créer un utilisateur',
  routes_create_admin: 'Créer un administrateur',
  routes_account: 'Compte',
  routes_version: 'Version'
};
